import {
  gql
} from "@apollo/client";

import {
  AmProtCustomizableDropDownOptionFragment,
  AmProtCustomizableRadioOptionFragment
} from "@/hooks/CartPage/ProductListing/productListingFragments.gql";

export const ProductListFragment = gql`
    fragment ProductListFragment on Cart {
        id
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        items {
            uid
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            robes_gifts_customization {
                label
                value
            }
            select_product_image
            available_product {
                sku
                uid
                id
                url_key
                name
            }
            product {
                uid
                name
                sku
                url_key
                thumbnail {
                    url(type: "thumbnail", width: 90, height: 132)
                }
                price {
                    regularPrice {
                        amount {
                            currency
                            value
                        }
                    }
                }

                media_gallery_entries {
                    uid
                    label
                    position
                    disabled
                    file
                }
                media_gallery {
                    label
                    url(width: 90, height: 132)
                    thumbnail: url(type: "thumbnail", width: 90, height: 132)
                    image: url(type: "image", width: 692, height: 1016)
                    position
                    disabled
                }

                stock_status
                # eslint-disable-next-line @graphql-eslint/require-id-when-available
                ... on ConfigurableProduct {
                    variants {
                        attributes {
                            uid
                            code
                            value_index
                        }
                        # eslint-disable-next-line @graphql-eslint/require-id-when-available
                        product {
                            uid
                            sku
                            stock_status
                            thumbnail {
                                url(type: "thumbnail", width: 90, height: 132)
                            }
                        }
                    }
                }
                ... on ConfigurableProduct {
                    configurable_options {
                        attribute_code
                        attribute_id
                        uid
                        label
                        # eslint-disable-next-line @graphql-eslint/require-id-when-available
                        values {
                            uid
                            default_label
                            label
                            store_label
                            use_default_value
                            value_index
                            swatch_data {
                                ... on ImageSwatchData {
                                    thumbnail
                                }
                                value
                            }
                        }
                    }
                
                }
                ampProtOption {
                    items {
                        uid
                        label
                        attribute_id
                        type
                        sort_order
                        ...AmProtCustomizableDropDownOptionFragment
                        ...AmProtCustomizableRadioOptionFragment
                    }
                }
            }
            prices {
                price {
                    currency
                    value
                }
                total_item_discount {
                    value
                }
            }
            quantity
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            ... on ConfigurableCartItem {
                # eslint-disable-next-line @graphql-eslint/require-id-when-available
                configurable_options {
                    id
                    configurable_product_option_uid
                    option_label
                    configurable_product_option_value_uid
                    value_label
                    __typename
                }
            }
            select_options {
                option_id
                option_value_id
            }
            custom_info {
                label
                value
            }
        }
    }
    ${AmProtCustomizableRadioOptionFragment}
    ${AmProtCustomizableDropDownOptionFragment}
`;
